import SearchIcon from "@mui/icons-material/Search";
import {styled} from "@mui/material/styles";
import {alpha, IconButton, InputAdornment, InputBase} from "@mui/material";
import {KeyboardEvent, useEffect, useState} from 'react';

export default function SearchBox({startSearch, onSearchTextChanged, placeholder = 'Search…'}) {
  const [text, setText] = useState('');
  useEffect(() => {
    onSearchTextChanged(text);
  }, [text]);

  const onKeyUp = (ev: KeyboardEvent<HTMLDivElement>) => {
    ev.stopPropagation();
    if (ev.key === 'Enter') {
      startSearch(text);
    }

  }
  return (
    <Search
      onKeyUp={onKeyUp}
    >
      <StyledInputBase
        placeholder={placeholder}
        value={text}
        onChange={ev => setText(ev.target.value)}
        inputProps={{'aria-label': 'search'}}
        endAdornment={
          <InputAdornment position="end" sx={{
            left: '-35px',
            position: 'relative'
          }}>
            <IconButton
              onPointerDown={ev => startSearch(text)}
              edge="end"
            >
              <SearchIcon sx={{color: '#AEAEB2'}}/>
            </IconButton>
          </InputAdornment>
        }
      />
    </Search>
  )
}

const StyledInputBase = styled(InputBase)(({theme}) => ({
  color: theme.palette.text.secondary,
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    '&:focus': {
      color: theme.palette.text.primary,
    },
  },
}));

const Search = styled('div')(({theme}) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.mode === 'dark'
    ? alpha('#FFFFFF', 0.08)
    : alpha('#000000', 0.06),
  transition: 'background-color 0.2s, border-color 0.2s',
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark'
      ? alpha('#FFFFFF', 0.12)
      : alpha('#000000', 0.09),
    borderStyle: 'solid',
    borderColor: theme.colors.primary.main,
    borderWidth: '2px',
  },
  '&:focus': {
    backgroundColor: theme.palette.mode === 'dark'
      ? alpha('#FFFFFF', 0.08)
      : alpha('#000000', 0.06),
    borderStyle: 'solid',
    borderColor: theme.colors.primary.main,
    borderWidth: '2px',
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
  },
}));
